import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainPart2FR() {
  const articleData = {
    title: 'Pourquoi certaines personnes nous épuisent-elles ? Partie 2',
    description: "Plus de schémas subtils qui drainent votre énergie. L'IA détecte la surexplication, les je-sais-tout, la confusion des emojis et plus.",
    slug: 'emotional-drain-part-2',
    publishDate: '2025-11-16',
    author: 'Rédaction Toxic Detector'
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Lien copié dans le presse-papiers !');
    }
  };
  return <>
      <MetaTags title="Pourquoi certaines personnes nous épuisent-elles ? Partie 2 | ToxicDetector" description="Plus de schémas subtils qui drainent votre énergie. L'IA détecte la surexplication, les je-sais-tout, la confusion des emojis et plus." keywords="épuisement émotionnel, vampires énergétiques, relations toxiques, analyse IA" canonical={`https://toxicdetector.com/fr/blog/${articleData.slug}`} ogType="article" ogImage="https://toxicdetector.com/images/logo.png" schema={[articleSchema]} data-id="element-5826" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-5827">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-5828">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-5829">
            <div className="flex items-center justify-between" data-id="element-5830">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-5831">
                <span className="text-2xl" data-id="element-5832">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-5833">
                  ToxicDetector
                </span>
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-5834">
                <Share2 size={20} className="text-gray-600" data-id="element-5835" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-5836">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-5837">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-5838" />
            Retour à l'Accueil
          </Link>

          <header className="mb-16" data-id="element-5839">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-5840">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-5841">
              <time dateTime={articleData.publishDate} data-id="element-5842">
                {new Date(articleData.publishDate).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-5843">•</span>
              <span data-id="element-5844">{articleData.author}</span>
            </div>
          </header>

          <div className="prose prose-lg max-w-none" data-id="element-5845">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-5846">
              Bienvenue dans la Partie 2 de notre série sur l'épuisement
              émotionnel. Dans la Partie 1, nous avons couvert les vampires
              énergétiques évidents. Maintenant, nous plongeons plus
              profondément dans les schémas plus subtils.
            </p>

            <section className="mb-16" data-id="element-5847">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5848">
                1️⃣ Le Surexplicateur
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5849">
                Quelqu'un qui répond à des questions simples par des romans et
                accapare votre énergie avec des détails inutiles.
              </p>
            </section>

            <section className="mb-16" data-id="element-5850">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5851">
                2️⃣ Le Je-Sais-Tout
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5852">
                Peu importe ce que vous dites, cette personne sait mieux ou a
                vécu pire. Un comportement classique de surenchère.
              </p>
            </section>

            <section className="mb-16" data-id="element-5853">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5854">
                3️⃣ Confusion des Emojis
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5855">
                Utiliser des emojis passifs-agressifs comme 🙂 ou 🙃 dans des
                contextes sérieux pour créer de la confusion.
              </p>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl mt-16" data-id="element-5856">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-5857">
              Protégez votre énergie.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-5858">
              Ne vous laissez pas épuiser. Découvrez qui est bon pour vous.
            </p>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-5859">
              Scanner maintenant →
            </Link>
          </div>

          <div className="mt-20" data-id="element-5860">
            <RelatedBlogPosts posts={[{
            title: 'Pourquoi certaines personnes nous épuisent-elles ?',
            description: "Apprenez comment l'IA de Toxic Detector détecte la communication unilatérale.",
            slug: 'emotional-drain-relationships-ai',
            emoji: '😮‍💨'
          }, {
            title: '7 Signes de Gaslighting',
            description: 'Découvrez 7 signes de gaslighting que notre IA détecte instantanément.',
            slug: '7-signs-of-gaslighting',
            emoji: '💀'
          }]} data-id="element-5861" />
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-5862">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-5863">
            <p className="text-gray-400 text-sm" data-id="element-5864">
              © {new Date().getFullYear()} ToxicDetector. Tous droits réservés.
            </p>
          </div>
        </footer>
      </div>
    </>;
}